/* app/ui/track/track.article */

import $ from 'jquery';

window.dataLayer = window.dataLayer || [];

var selectors = {
	article: '.js-article',
	date: '.js-article-date',
};

const articleTypes = ["insight", "news"];

var TrackArticle = {
	init: function () {
		const article = document.querySelector(selectors.article);
		const date = document.querySelector(selectors.date);

		if (article) {
			const articleDate = date.getAttribute('data-article-date');
			const articleType = article.getAttribute('data-article-type');

			if (articleTypes.includes(articleType.toLowerCase())) {
				window.dataLayer.push(
					{
						event: 'article_view',
						eventData: {
							articleType: articleType,
							publishDate: articleDate,
							nodeId: article.getAttribute('data-article-id')
						}
					}
				);
			}
		}
	}
};

export { TrackArticle };
